export function exportSVG(params: any, bpmnjs: any) {
  return {
    args: [
    ],
    exec: async function () {
      const ret = { result: null, error: null } as BpmnExportResult;

      try {
        const { svg } = await bpmnjs.saveSVG();
        ret.result = svg;
      } catch (err) {
        console.log(err);
        ret.error = err;
      }
      return ret;
    }
  };
}
exportSVG.$inject = ['cli._params', 'bpmnjs'];
